(function () {
  function init(range) {
    if (range.dataset.compareReady) return;
    range.dataset.compareReady = 'true';
    var frame = range.closest('.at-compare-frame');
    if (!frame) return;
    var beforeWrap = frame.querySelector('[data-compare-before-wrap]');
    var handle = frame.querySelector('[data-compare-handle]');
    var beforeImg = beforeWrap ? beforeWrap.querySelector('img') : null;

    function update() {
      var value = range.value;
      if (beforeWrap) beforeWrap.style.width = value + '%';
      if (beforeImg) beforeImg.style.width = frame.offsetWidth + 'px';
      if (handle) handle.style.left = value + '%';
    }

    range.addEventListener('input', update);
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-compare-range]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();
